/**
 * itemall API call
 * 
 */
 {
    /**
     * item_listデータを取得
     * 
     * @param orderby 並び順に使うデータ名 date, post_title or tax_kind_name defalut date
     * @param order データの並び順 asc or desc default desc
     * 
     */
    function requestItemList(orderby = 'rubi', order = 'asc') {
        reqURL = `/wp-json/kp/v2/itemall`
        
        $.ajax({
            url: reqURL,
            dataType: 'json',
            data: {
                orderby: orderby,
                order: order
            }
        })
        .done(function(result){
            renderTable(result);
        })
        .fail(function(){
            return 'failed'
        })
    }

    /**
     * テーブルを出力
     * 
     * @param data item_listデータ
     * 
     */
    function renderTable(data){
        let tableBody = ''
        for(const item of data) {
            const aRow = `
            <tr>
                <td>
                    <a href="${item['url']}">${item['post_title']}</a><br>
                    <span class="kp-page-itemall-list-toolruby">${item['rubi']}</span>
                </td>
                <td>
                    <span class="kp-badge-s-${item['tax_kind_slug']}">
                    ${item['tax_kind_name']}
                    </span>
                </td>
                <td>
                    ${item['description_value']}
                </td>
            </tr>`
            tableBody += aRow
        }
        document.querySelector('#item-summary-table tbody').innerHTML = tableBody
    }

    /**
     * UI（ソートボタン）のセットアップ
     * 
     */
    function uiSetup() {
        /**
         * ソートボタンのclickイベントを設定
         */
        document.querySelectorAll('.kp-sort-btn').forEach(function(elm){
            elm.addEventListener('click', function(e){
                t = e.currentTarget
                PubSub.publish('sortChanged', t)
                
            })

            /**
             * Event Subscription
             */
            elm.subscription = PubSub.subscribe('sortChanged', function(event, target){
                if(elm === target) {
                    elm.classList.add('kp-sort-active')
                    requestItemList(elm.dataset['orderby'], elm.dataset['order']);
                } else {
                    elm.classList.remove('kp-sort-active')
                }
            })
        })
    }

    /**
     * item_list_jsページのときだけロード時にデータを取得
     * 
     */
    if(document.querySelector('body').classList.contains('page-itemall')){
        uiSetup()
        requestItemList()
    }
 }


// WEBPACK FOOTER //
// ./src/itemall.js